export const hasSoleNhlnNetwork = output => {
  let assignedNetworks = [];
  if (Array.isArray(output?.broadcasters)) {
    assignedNetworks = output.broadcasters;
  } else if (Array.isArray(output?.networks)) {
    assignedNetworks = output.networks;
  }

  if (assignedNetworks.length !== 1) return false;

  const network = assignedNetworks[0];
  const code = typeof network === 'string' ? network : network?.code;
  return String(code || '').trim().toUpperCase() === 'NHLN';
};

export const getSoleNhlnShareModelOverride = output =>
  output?.name === 'US National' && hasSoleNhlnNetwork(output)
    ? 'RS-USA-N-2'
    : null;
